import React from 'react'
import { Thumbnail } from '../../../feed/AttachmentsContainer/Thumbnail/Thumbnail'
import { ProcessedDocument } from '../../../../types/document-upload'

interface MessageBarDocumentsProps {
  documents: ProcessedDocument[]
  onDocumentRemove: (id: string) => void
}

export const MessageBarDocuments = ({
  documents,
  onDocumentRemove,
}: MessageBarDocumentsProps): JSX.Element => {
  return (
    <>
      {documents.length > 0 && (
        <div className="flex flex-wrap gap-3 px-2 pt-3">
          {documents.map((doc, index) => (
            <Thumbnail
              key={`${doc.id}${doc.name}`}
              id={doc.id as string}
              icon={doc.icon}
              title={doc.name || `File-${index}`}
              description={doc.size || 'Unknown file size'}
              index={index}
              onThumbnailRemove={onDocumentRemove}
              loading={doc.uploading}
            />
          ))}
        </div>
      )}
    </>
  )
}
